import type { ReactNode } from "react";

import type { WPImageElement } from "../../../../models/WPContentBlock";

export async function fetchImageElement(
  model: WPImageElement,
): Promise<ReactNode> {
  const { ImageElement } = await import(
    "../../../components/blocks/ImageElement/ImageElement"
  );

  return <ImageElement model={model} />;
}
